goog.provide("shadow.js.shim.module$$cloudpermit$map_component");
goog.provide("module$shadow_js_shim_module$$cloudpermit$map_component");
shadow.js.shim.module$$cloudpermit$map_component = shadow.js.nativeProvides["@cloudpermit/map-component"] = shadow$bridge("@cloudpermit/map-component");
module$shadow_js_shim_module$$cloudpermit$map_component.default = shadow.js.shim.module$$cloudpermit$map_component;
